import PropTypes from 'prop-types';
import { memo } from 'react';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';
import Tooltip from 'shopper/components/Tooltip';

import placeholder from 'lib/placeholder';

const DislikeButton = ({ isDisliked, onClick }) => (
  <Tooltip.Root>
    <Tooltip.Trigger>
      <Button
        icon={<Icon name={isDisliked ? 'dislike-filled' : 'dislike'} />}
        size="size4"
        type="neutral-ghost"
        onClick={onClick}
      />
    </Tooltip.Trigger>
    <Tooltip.Box className="w-max">
      {isDisliked ? placeholder('tips.disliked') : placeholder('tips.dislike')}
    </Tooltip.Box>
  </Tooltip.Root>
);

DislikeButton.propTypes = {
  isDisliked: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default memo(DislikeButton);
